import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import LogoImage from "../../../images/KuwaitAirways/app_logo.png"
import { Link as Linkroute } from "react-router-dom";


export default function Appbar(props) {
  const panelMenuArray = [
    {
      id: 1,
      text: 'Dashboard',
      subText: '',
      link: '/route-profitability/dashboard',
      show: true,
      key: "dashboard",
      otherLink: '/route-profitability/dashboard-detail',
      defaultBreadcrumbs : {text : "Overview", link:"#"}
    },
    {
      id: 2,
      text: 'Operational Parameters',
      subText: '',
      link: '/route-profitability/operational',
      show: true,
      key: "operational",
      defaultBreadcrumbs : {text : "Table View", link:"#"}
    },
     {
      id: 3,
      text: 'Analytics',
      subText: '',
      link: '/route-profitability/analytics',
      show: true,
      key: "analytics",
      defaultBreadcrumbs : {text : "Table View", link:"#"}
    },
    {
      id: 4,
      text: 'Load Factor AI',
      link: '/route-profitability/ai',
      show: true,
      key: "ai",
      defaultBreadcrumbs : {text : "Kanban Board", link:"#"}
    },
    {
      id: 5,
      text: 'Key Initiatives ',
      subText: '',
      link: '/route-profitability/key-initiatives',
      show: true,
      key: "key",
      defaultBreadcrumbs : {text : "Table View", link:"#"}
    },
    {
      id: 6,
      text: 'Datasources',
      link: '/route-profitability/datasources',
      show: true,
      key: "datasources",
      defaultBreadcrumbs : {text : "Kanban Board", link:"#"}
    }
  ]
  


  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (link) =>{
        window.location = link;
  }

  const setBreadcrumbsList = (data)=>{
        let breadcrumbs = []
        breadcrumbs.push({text:data.text, link : data.link})
        breadcrumbs.push(data.defaultBreadcrumbs)
        props.setBreadcrumbs(breadcrumbs);
    }


  return (
    <div className="route-profitability-bar">
      <AppBar position="fixed">
        <Toolbar className="top-navbar">
          <div className="logo">
            <img src={LogoImage} className="img-logo"/> 
            <h3>Route Profitability</h3>
          </div>
          <div className="menu-navigation">
            {
                (props.showMenu || window.location.pathname !== '/route-profitability/panel') && (
                    panelMenuArray && panelMenuArray.map((item, index) => (
                        <Linkroute to={item.link}  className="top-menu" onClick={()=>{props.setActiveMenu(item.text);}}>
                          <span className={(props.activeMenu == item.text || window.location.pathname === item.link || window.location.pathname === item.otherLink)? 'active menu-item' : 'menu-item'}>{item.text}</span>
                        </Linkroute>
                    ))
               )
            }
            
            <div className="user-icon">
              <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={open}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleClose}>Profile</MenuItem>
                  <MenuItem onClick={handleClose}>My account</MenuItem>
                </Menu>
              </div>
          </div>
          
        </Toolbar>
      </AppBar>
    </div>
  );
}
